/**
 * Created by henian.xu on 2018/7/18.
 *
 */

import { Mb } from './Mb';

class BenefitCard extends Mb {
    constructor() {
        super();
        this.baseUrl += '/benefitCard';
    }

    data({ cardName, isAvailable, currentPage, pageSize } = {}) {
        return super.get('/data', {
            cardName,
            isAvailable,
            currentPage,
            pageSize,
        });
    }

    getDetail({ id }) {
        return super.get('/get', { id }).then(json => {
            const { cardLogo } = json.data.data.benefitCard;
            const { fileBasePath } = json.data.data;
            if (!cardLogo) {
                json.data.data.benefitCard.cardLogo = [];
            } else {
                json.data.data.benefitCard.cardLogo = cardLogo.split(',').reduce((prev, curr) => {
                    prev.push({
                        name: curr,
                        address: fileBasePath + curr,
                    });
                    return prev;
                }, []);
            }
            return json;
        });
    }

    save({ id, cardName, cardAmount, cardLogo, cardDesc, isAvailable, validityType, validityValue, detailJson } = {}) {
        const cardLogoStr = cardLogo
            .reduce((prev, curr) => {
                prev.push(curr.name);
                return prev;
            }, [])
            .join(',');
        return super.post('/save', {
            id,
            cardName,
            cardAmount,
            cardLogo: cardLogoStr,
            cardDesc,
            isAvailable,
            validityType,
            validityValue,
            detailJson,
        });
    }

    delete({ ids } = {}) {
        return super.post('/delete', {
            ids,
        });
    }

    status({ id, isAvailable }) {
        return super.post('/status', {
            id,
            isAvailable,
        });
    }
}

export default new BenefitCard();
export { BenefitCard };
